export default "__VITE_ASSET__WM693vJU__"